import React from 'react';
import { PsPage } from '../../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { BreadcrumbsManagerInstance } from '../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../shared/breadcrumbs/Breadcrumbs';
import NotificationListCard from './NotificationListCard';

export class NotificationListScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.NOTIFICATIONS,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_NOTIFICACIONES')} breadcrumbs={breadcrumbs}>
                <NotificationListCard/>
            </PsPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/notifications/list/NotificationListScreen.jsx